module.exports = {"130534100":"葛仙庄镇","130534101":"连庄镇","130534102":"油坊镇","130534103":"谢炉镇","130534104":"王官庄镇","130534105":"坝营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130534.json
// module id = 234
// module chunks = 0